import { render, staticRenderFns } from "./UpdateNicknameDialog.vue?vue&type=template&id=712e907e&scoped=true&"
import script from "./UpdateNicknameDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateNicknameDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateNicknameDialog.vue?vue&type=style&index=0&id=712e907e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712e907e",
  null
  
)

export default component.exports